export default {
  getID: (state) => state.itemId,
  getApplicationType: (state) => state.applicationType,

};